import { RegisterForm } from '../../components/auth/register-form'

export default function Register() {
  return <RegisterForm />
}
